<!-- eslint-disable vue/html-closing-bracket-newline -->
<template>
  <div>
    <b-card>
      <b-tabs content-class="mt-2" justified>
        <b-tab active title="Page">
          <Page :marketplaces="marketplaces" />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import { BTabs, BTab, BCard, BCardText, BLink } from "bootstrap-vue";
import Page from "./partials/Page.vue";
export default {
  components: {
    Page,
    BCard,
    BCardText,
    BLink,
    BTabs,
    BTab,
  },
  mounted() {
    this.$store.dispatch("getMarketplace");
  },
  computed: {
    marketplaces() {
      return this.$store.getters.getMarketplace;
    },
  },
};
</script>

<style></style>
